import { render, staticRenderFns } from "./VaColorInput.demo.vue?vue&type=template&id=6f2c2b62&"
import script from "./VaColorInput.demo.vue?vue&type=script&lang=js&"
export * from "./VaColorInput.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports